import React, { useState } from "react";

import {
  HANDLE_HINT,
  HANDLE_PATTERN,
  HANDLE_PLACEHOLDER,
  normalizeHandleInput,
  validateHandle,
} from "./handleValidation";

function ProfileSlugSection({ handle, onHandleChange, error = null, showError = false }) {
  const [isHintOpen, setIsHintOpen] = useState(false);
  const [touched, setTouched] = useState(false);

  const toggleHint = () => setIsHintOpen((prev) => !prev);

  const inlineError =
    error || ((showError || touched) ? validateHandle(handle) : null);
  const describedBy = inlineError
    ? "profile-handle-rules profile-handle-error"
    : "profile-handle-rules";

  const handleChange = (event) => {
    onHandleChange(normalizeHandleInput(event.target.value));
  };

  return (
    <section
      className="ap-pane"
      aria-labelledby="ep-pane-site-link"
      data-section="profile-handle"
    >
      <header className="ap-pane__head">
        <h2 id="ep-pane-site-link">
          <i className="fa-solid fa-link" aria-hidden="true"></i>Посилання на профіль
        </h2>
        <p>Налаштуйте читабельне ім'я для URL вашого профілю.</p>
      </header>

      <div className="ap-row">
        <div className="ap-field ap-field--wide">
          <div className="d-flex align-items-center gap-2">
            <label htmlFor="profile-handle" className="mb-0">
              Ім'я посилання на сайті{" "}
              <span className="req" aria-hidden="true">*</span>
            </label>
            <button
              type="button"
              className={`question-btn${isHintOpen ? "" : " collapsed"}`}
              data-disclosure-trigger="profile-handle-hint"
              aria-expanded={isHintOpen}
              aria-controls="profile-handle-hint"
              aria-label="Що це таке?"
              onClick={toggleHint}
            >
              <i className="fa-solid fa-question" aria-hidden="true"></i>
            </button>
          </div>
          <input
            type="text"
            className={`form-control${inlineError ? " is-invalid" : ""}`}
            id="profile-handle"
            name="handle"
            data-field="handle"
            autoComplete="off"
            autoCapitalize="none"
            spellCheck={false}
            required
            aria-required="true"
            pattern={HANDLE_PATTERN.source}
            aria-invalid={inlineError ? "true" : undefined}
            aria-describedby={describedBy}
            placeholder={HANDLE_PLACEHOLDER}
            value={handle}
            onChange={handleChange}
            onBlur={() => setTouched(true)}
          />
          <small id="profile-handle-rules" className="form-hint">
            {HANDLE_HINT}
          </small>
          {inlineError ? (
            <div
              id="profile-handle-error"
              className="invalid-feedback d-block"
              role="alert"
            >
              {inlineError}
            </div>
          ) : null}
        </div>
      </div>

      <div
        className={`collapse question-area${isHintOpen ? " show" : ""}`}
        id="profile-handle-hint"
        data-disclosure-panel="profile-handle-hint"
      >
        <div className="card card-body">
          Замість класичного посилання на ваш профіль: <br />
          <strong>https://riestro.com/user/102</strong><br />
          буде ваше вищевказане ім'я: <br />
          <strong>https://riestro.com/user/{HANDLE_PLACEHOLDER}</strong>
        </div>
      </div>
    </section>
  );
}

export default ProfileSlugSection;
